import { useEffect, useMemo, useState } from "react";
import {
  AUTHORING_LIBRARY_LANGUAGE_CHANGED_EVENT,
  AUTHORING_LANGUAGE_LABELS,
  clearStoredAuthoringLanguage,
  getStoredAuthoringLanguage,
  setStoredAuthoringLanguage,
  normalizeAuthoringLanguageCode,
  type AuthoringLibraryLanguage
} from "./authoringLibraryLanguages";

export function useAuthoringLibraryLanguage(preferredLanguage?: string) {
  const [language, setLanguage] = useState<AuthoringLibraryLanguage>(() => {
    return (
      getStoredAuthoringLanguage() ||
      normalizeAuthoringLanguageCode(preferredLanguage)
    );
  });

  useEffect(() => {
    const handleAuthoringLanguageChanged = () => {
      setLanguage(
        getStoredAuthoringLanguage() ||
          normalizeAuthoringLanguageCode(preferredLanguage)
      );
    };

    window.addEventListener(
      AUTHORING_LIBRARY_LANGUAGE_CHANGED_EVENT,
      handleAuthoringLanguageChanged
    );

    return () => {
      window.removeEventListener(
        AUTHORING_LIBRARY_LANGUAGE_CHANGED_EVENT,
        handleAuthoringLanguageChanged
      );
    };
  }, [preferredLanguage]);

  useEffect(() => {
    if (!getStoredAuthoringLanguage()) {
      setLanguage(normalizeAuthoringLanguageCode(preferredLanguage));
    }
  }, [preferredLanguage]);

  const options = useMemo(
    () =>
      Object.entries(AUTHORING_LANGUAGE_LABELS).map(([value, label]) => ({
        value,
        label
      })),
    []
  );

  return {
    language,
    options,
    setLanguage: (nextLanguage: string) =>
      setStoredAuthoringLanguage(nextLanguage),
    resetLanguage: () => clearStoredAuthoringLanguage()
  };
}
